import React, { createContext, useContext, useState } from "react";

let pendingDevRequest = false;

export const getDevMode = () => pendingDevRequest;
export const useDevRequest = () => {
  pendingDevRequest = true;
  setTimeout(() => {
    pendingDevRequest = false;
  }, 0);
};

interface DevModeContextType {
  isDevMode: boolean;
  toggleDevMode: () => void;
}

export const DevModeContext = createContext<DevModeContextType>({
  isDevMode: false,
  toggleDevMode: () => {},
});

export const DevModeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isDevMode, setIsDevMode] = useState(false);

  const toggleDevMode = () => {
    setIsDevMode((prev) => {
      pendingDevRequest = !prev;
      return !prev;
    });
  };

  return (
    <DevModeContext.Provider value={{ isDevMode, toggleDevMode }}>
      {children}
    </DevModeContext.Provider>
  );
};

export const useDevMode = () => useContext(DevModeContext);
